export default __webpack_public_path__ + "assets/bottel.dac6c1e2.glb";